import {
  ArrayField,
  AutocompleteInput,
  ChipField,
  FormTab,
  FormTabProps,
  Labeled,
  ReferenceInput,
  SingleFieldList,
  TextField,
  required,
} from 'react-admin';
import { Typography } from '@mui/material';

import CraftPageSection from 'src/components/CraftPageSection';
import CraftTwoColumns from 'src/components/CraftTwoColumns';
import TextInput from 'src/inputs/TextInput';

const DetailsTab = ({ mode, ...rest }: Omit<FormTabProps, 'label'> & { mode: 'create' | 'edit' }) => (
  <FormTab label="Details" {...rest}>
    <CraftPageSection title="General">
      <CraftTwoColumns
        left={
          <>
            {mode === 'edit' && (
              <Labeled label="Client ID" sx={{ mb: 3.5 }}>
                <TextField source="id" />
              </Labeled>
            )}
            <TextInput source="name" validate={required()} autoFocus={mode === 'create'} />
            <TextInput source="description" multiline />
          </>
        }
        right={
          <>
            <ReferenceInput
              source="org_id"
              reference="organizations"
              filter={{ 'deleted_at@_is_null': true }}
              sort={{ field: 'name', order: 'ASC' }}
            >
              <AutocompleteInput
                label="Organization"
                optionValue="id"
                optionText={(record: { id: number; name: string }) => `${record.name} (ID: ${record.id})`}
                validate={required()}
                filterToQuery={(q) => ({ name: q })}
                disabled={mode !== 'create'}
              />
            </ReferenceInput>
            <ReferenceInput
              source="legacy_client_id"
              reference="external_api_clients"
              filter={{ 'archived_at@_is_null': true }}
              sort={{ field: 'name', order: 'ASC' }}
            >
              <AutocompleteInput
                label="Legacy API Client"
                optionValue="id"
                optionText={(record: { id: number; name: string }) => `${record.name} (ID: ${record.id})`}
                filterToQuery={(q) => ({ name: q })}
              />
            </ReferenceInput>
          </>
        }
      />
    </CraftPageSection>
    {mode === 'edit' && (
      <CraftPageSection title="Roles">
        <ArrayField source="service_roles">
          <SingleFieldList linkType={false} empty={<Typography variant="subtitle2">No roles found</Typography>}>
            <ChipField source="service_role.display_name" />
          </SingleFieldList>
        </ArrayField>
      </CraftPageSection>
    )}
  </FormTab>
);

export default DetailsTab;
